import React, { useState } from "react";
import {
  EyeIcon,
  EyeSlashIcon,
} from "@heroicons/react/24/outline";

const Login = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({
    username: "",
    password: "",
    rememberMe: false,
  });

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Check for required credentials
    if (formData.username === "doctor" && formData.password === "apollo123") {
      console.log("Login successful:", formData);
      // Store login status in localStorage
      localStorage.setItem("isAuthenticated", "true");
      // Redirect to homepage after successful login
      window.location.href = "/";
    } else {
      // Show error if credentials don't match
      alert("Invalid credentials. Please use Login ID: doctor and Password: apollo123");
    }
  };

  return (
    <div className="h-screen overflow-hidden bg-apollo-gray">
      {/* Background with Apollo Medical Theme */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-20 left-10 w-64 h-64 bg-green-100 rounded-full opacity-30 blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-48 h-48 bg-apollo-accent/20 rounded-full opacity-30 blur-2xl"></div>
        <div className="absolute top-1/2 left-1/4 w-32 h-32 bg-green-200/10 rounded-full"></div>
        <div className="absolute bottom-1/4 right-1/4 w-24 h-24 bg-apollo-accent/10 rounded-full"></div>
      </div>

      <div className="relative h-screen flex">
        {/* Left Side - Branding */}
        <div className="hidden lg:flex lg:w-1/2 bg-gradient-to-br from-apollo-primary via-apollo-primary to-blue-800">
          {/* Background Medical Icons */}
          <div className="absolute inset-0 opacity-10">
            <div className="absolute top-20 left-20 w-16 h-16 border-2 border-white rounded-full"></div>
            <div className="absolute bottom-32 right-20 w-12 h-12 bg-white rounded-full"></div>
            <div className="absolute top-1/2 left-1/4 w-8 h-8 bg-white/50 rounded-full"></div>
            <div className="absolute bottom-1/4 left-1/3 w-20 h-20 border border-white rounded-full"></div>
          </div>

          <div className="relative z-10 flex flex-col justify-center items-center p-12 text-white">
            <div className="text-center space-y-8">
              <img
                src="https://www.apollohospitals.com/themes/custom/apollo/assets/svg/apollo-logo.svg"
                alt="Apollo Hospitals"
                className="h-20 w-auto mx-auto filter brightness-0 invert"
              />

              <div className="space-y-4">
                <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold">
                  Welcome to Apollo Hospitals
                </h1>
                <p className="text-lg sm:text-xl opacity-90">Excellence in Healthcare</p>
                <p className="text-base sm:text-lg opacity-80 leading-relaxed max-w-md">
                  Access homepage and manage your healthcare
                  operations with our advanced management system.
                </p>
              </div>

            </div>
          </div>
        </div>

        {/* Right Side - Login Form */}
        <div className="w-full lg:w-1/2 flex items-center justify-center p-4 sm:p-6 lg:p-6">
          <div className="max-w-md w-full space-y-4">
            {/* Header */}
            <div className="text-center">
              <h2 className="text-2xl sm:text-3xl font-bold text-apollo-primary">
                Login Access
              </h2>
              <p className="mt-2 text-sm sm:text-base text-apollo-secondary">
                Secure login to homepage
              </p>
            </div>

            {/* Login Form */}
            <div className="bg-white p-6 sm:p-8 rounded-2xl shadow-xl border border-apollo-accent/10">
              <form className="space-y-5" onSubmit={handleSubmit}>
                {/* Username */}
                <div>
                  <label
                    htmlFor="username"
                    className="block text-sm font-semibold text-apollo-secondary mb-2"
                  >
                    Username
                  </label>
                  <div className="relative">
                    <input
                      id="username"
                      name="username"
                      type="text"
                      className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-apollo-accent focus:border-apollo-accent transition-all bg-apollo-gray/30 text-base"
                      placeholder="Enter Username"
                      value={formData.username}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>

                {/* Password */}
                <div>
                  <label
                    htmlFor="password"
                    className="block text-sm font-semibold text-apollo-secondary mb-2"
                  >
                    Password
                  </label>
                  <div className="relative">
                    <input
                      id="password"
                      name="password"
                      type={showPassword ? "text" : "password"}
                      className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-apollo-accent focus:border-apollo-accent transition-all bg-apollo-gray/30 pr-12 text-base"
                      placeholder="Enter Password"
                      value={formData.password}
                      onChange={handleInputChange}
                    />
                    <button
                      type="button"
                      className="absolute inset-y-0 right-3 flex items-center"
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      {showPassword ? (
                        <EyeSlashIcon className="h-5 w-5 text-gray-400 hover:text-apollo-accent transition-colors" />
                      ) : (
                        <EyeIcon className="h-5 w-5 text-gray-400 hover:text-apollo-accent transition-colors" />
                      )}
                    </button>
                  </div>
                </div>

                {/* Remember Me */}
                <div className="flex items-center justify-between">
                  <div className="flex items-center">
                    <input
                      id="rememberMe"
                      name="rememberMe"
                      type="checkbox"
                      className="h-4 w-4 text-apollo-accent focus:ring-apollo-accent border-gray-300 rounded"
                      checked={formData.rememberMe}
                      onChange={handleInputChange}
                    />
                    <label
                      htmlFor="rememberMe"
                      className="ml-2 block text-sm text-apollo-secondary font-medium"
                    >
                      Remember me
                    </label>
                  </div>

                  <div className="text-sm">
                    <button
                      type="button"
                      className="text-apollo-accent hover:text-green-600 font-semibold transition-colors"
                    >
                      Forgot password?
                    </button>
                  </div>
                </div>

                {/* Submit Button */}
                <div className="space-y-4">
                  <button
                    type="submit"
                    className="w-full bg-gradient-to-r from-apollo-accent to-green-600 hover:from-apollo-accent/90 hover:to-green-600/90 text-white px-8 py-4 rounded-lg font-bold text-base transition-all duration-300 hover:shadow-lg transform hover:scale-105"
                  >
                    Sign in to Homepage
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
